import React from "react"
import styles from "./styles.module.scss"
import Button from "../Button"
import {
  modalDotLeft,
  modalDotRight,
  jd100,
  jd50,
  aqy,
  tx,
  walmart,
  claimFail,
} from "../../images"

const data = {
  "WBX-JDK100": {
    detail: "京东商城购物券100元",
    imgUrl: jd100,
  },
  "WBX-JDK50": {
    detail: "京东商城购物券50元",
    imgUrl: jd50,
  },
  "WBX-WEM20": {
    detail: "沃尔玛购物券20元",
    imgUrl: walmart,
  },
  "WBX-AQYSP": {
    detail: "爱奇艺月卡",
    imgUrl: aqy,
  },
  "WBX-TXSP": {
    detail: "腾讯视频月卡",
    imgUrl: tx,
  },
}

const RulesModal = (props) => {
  const { toggleModal, success, giftCode, msg } = props
  if (success) {
    return (
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.modal}>
            <div className={styles.header}>
              <div className={styles.leftDot}>
                <img src={modalDotLeft} alt="dot" />
              </div>
              <div className={styles.text}>兑换成功</div>
              <div className={styles.rightDot}>
                <img src={modalDotRight} alt="dot" />
              </div>
            </div>
            <div className={styles.prize}>
              <img src={data[giftCode].imgUrl} alt="prize won" />
            </div>
            <div className={styles.provisions}>
              恭喜您，抢到了“{data[giftCode].detail}
              ”，您也可以在“我的”页面-活动奖品中查看您的奖品。
            </div>
            <div className={styles.btnWrap}>
              <Button title="我知道了" size="sm" onClick={toggleModal} />
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.modal}>
            <div className={styles.header}>
              <div className={styles.leftDot}>
                <img src={modalDotLeft} alt="dot" />
              </div>
              <div className={styles.fail}>兑换失败</div>
              <div className={styles.rightDot}>
                <img src={modalDotRight} alt="dot" />
              </div>
            </div>
            <div className={styles.claimFail}>
              <img src={claimFail} alt="prize won" />
            </div>
            <div className={styles.provisions}>{msg}</div>
            <div className={styles.btnWrap}>
              <Button title="我知道了" size="sm" onClick={toggleModal} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default RulesModal
